import React, {useContext} from "react";
import {UserContext} from "@web/hooks/context";
import Splash from "@web/components/Splash";
// import ConsoleRouter from "./ConsoleRouter";
import RequireLine from "@web/ui/containers/RequireLine";
import HomeMiddleware from "./HomeMiddleware";
import WithLineOnboarding from './WithLineOnboarding';
import {Redirect} from 'wouter';

export default function Home() {
  const [, user] = useContext(UserContext);
  return (user && !user.isAnonymous) ?
    <HomeMiddleware>
      <RequireLine>
        <WithLineOnboarding>
          <Redirect to="/collections/activity" />
        </WithLineOnboarding>
      </RequireLine>
    </HomeMiddleware> :
  <Splash/>;
}
